<template>
  <div>
    <div shadow="hover" style="margin-bottom: 12px; padding: 10px">
      <el-form :inline="true" :model="formInline" @submit.native.prevent>
        <el-form-item label="门店仓库">
          <customer-store-select
            :defaultFirst="true"
            style="width: 206px"
            v-model="storeGuid"
            placeholder="门店"
          />
        </el-form-item>
        <el-form-item label="搜索内容">
          <el-input
            v-model="formInline.queryValue"
            @change="queryClick"
            placeholder="关键词"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div shadow="hover" style="min-height: 150px" v-loading="!pageData && loading">
      <div v-if="storeGuid">
        <div style="padding: 10px" v-if="pageData">
          <div style="margin-bottom: 5px">
            <el-button type="primary" @click="batchCreateClick"> 批量创建 </el-button>
            <el-button type="primary" @click="createClick"> 新建一级货位 </el-button>
            <el-button @click="refreshList" :loading="pageData && loading">
              刷新
            </el-button>
          </div>
          <el-table
            lazy
            ref="table"
            :data="pageData"
            :load="loadChildren"
            :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
            @expand-change="handleExpandChange"
            row-key="guid"
          >
            <el-table-column prop="name" label="货位名称" min-width="220">
              <template slot-scope="scope">
                <span style="color: #333333">
                  {{ scope.row.name }}
                </span>
                <span v-if="scope.row.desc" style="color: #919191; margin-left: 5px">
                  {{ scope.row.desc }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="guid" label="货位编号" width="220"> </el-table-column>
            <el-table-column prop="optSort" label="排序编号" width="120">
            </el-table-column>
            <el-table-column prop="childrenCount" label="下级货位" width="120">
            </el-table-column>
            <el-table-column prop="action" label="操作" width="220" fixed="right">
              <template slot-scope="scope">
                <template v-if="scope.row.parentGuid == '0'">
                  <el-link type="primary" @click="createChildrenClick(scope.row)">
                    新建二级货位
                  </el-link>
                  <el-divider direction="vertical"></el-divider>
                </template>
                <el-link type="primary" @click="editClick(scope.row)"> 编辑 </el-link>
                <el-divider direction="vertical"></el-divider>
                <el-link type="danger" @click="deleteClick(scope.row)"> 删除 </el-link>
              </template>
            </el-table-column>
          </el-table>
          <div style="padding: 20px">
            <span style="color: #919191">
              *
              店内货位为商品线上销售属性，可自行按需设置，设置后会在销售页面按照对应货位进行商品展示。
            </span>
          </div>
        </div>
        <el-empty v-else-if="!loading" :description="errorMsg" :image-size="100">
          <el-button v-if="errorMsg" @click="refreshList" size="small">
            重新加载
          </el-button>
        </el-empty>
      </div>
      <el-empty v-else description="请选择门店" :image-size="100"> </el-empty>
    </div>
  </div>
</template>

<script>
import customerStoreSelect from "../../../../components/business/customerStoreSelect.vue";
import formPage from "./__store_shelf_form.vue";
import batchFormPage from "./__store_shelf_batch.vue";

export default {
  components: { customerStoreSelect },
  props: {
    params: {
      type: Object,
      default: () => {
        return {};
      },
    },
    query: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    defaultParams() {
      return Object.assign(
        {
          storeGuid: this.storeGuid,
        },
        this.queryModel || {}
      );
    },
    pageParams() {
      return Object.assign({}, (this.$route && this.$route.params) || {}, this.params);
    },
    pageQuery() {
      return Object.assign({}, (this.$route && this.$route.query) || {}, this.query);
    },
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      pageData: null,
      storeGuid: "",
      queryModel: {},
      formInline: {
        queryValue: "",
      },
      deleteLoading: false,
      currentParentGuid: null,
      tableTreeRefreshTool: {},
    };
  },
  watch: {
    storeGuid() {
      this.commitState({ curStoreGuid: this.storeGuid });
      this.refreshList();
    },
  },
  methods: {
    clearClick() {
      this.formInline = {
        queryValue: "",
      };
      this.queryModel = {};
    },
    queryClick() {
      this.queryModel = Object.assign({}, this.formInline);
    },
    editClick(row) {
      this.$drawer.openDrawer(
        {
          title: "编辑货位",
          component: formPage,
          refresh: () => {
            this.refreshByRow(row.parentGuid);
          },
          params: {
            parentGuid: row.parentGuid,
            storeGuid: row.storeGuid,
            guid: row.guid,
          },
        },
        true
      );
    },
    deleteClick(row) {
      this.$confirm("确定删除?", "提示", {
        type: "warning",
      }).then(() => {
        this.requestApi(
          "biz.customer.store.shelf.delete",
          {
            guid: row.guid,
            storeGuid: row.storeGuid,
          },
          { showError: true }
        ).then(() => {
          this.$drawer.refreshDrawer();
          this.success("删除成功");
          this.refreshByRow(row.parentGuid);
        });
      });
    },
    createChildrenClick(row) {
      this.$drawer.openDrawer(
        {
          title: "新建二级货位",
          component: formPage,
          refresh: () => {
            this.refreshByRow(row.guid);
          },
          params: {
            parentGuid: row.guid,
            storeGuid: row.storeGuid,
          },
        },
        true
      );
    },
    batchCreateClick() {
      this.$drawer.openDrawer(
        {
          title: "批量创建货位",
          component: batchFormPage,
          refresh: this.refreshList,
          params: {
            storeGuid: this.storeGuid,
          },
        },
        true
      );
    },
    createClick() {
      this.$drawer.openDrawer(
        {
          title: "新建一级货位",
          component: formPage,
          refresh: this.refreshList,
          params: {
            storeGuid: this.storeGuid,
          },
        },
        true
      );
    },
    loadChildren(tree, treeNode, resolve) {
      this.currentParentGuid = tree.guid;
      this.tableTreeRefreshTool[tree.guid] = {};
      this.tableTreeRefreshTool[tree.guid].resolve = resolve;
      this.tableTreeRefreshTool[tree.guid].expandCount = 0;
      this.requestApi(
        "biz.customer.store.shelf.list",
        Object.assign({}, this.defaultParams, {
          parentGuid: tree.guid,
        })
      )
        .then((resp) => {
          resolve(
            (resp.data.list || []).map((item) => {
              return Object.assign(
                {
                  hasChildren: item.childrenCount > 0,
                },
                item
              );
            })
          );
        })
        .catch((err) => {
          resolve([]);
        });
    },
    handleExpandChange(tree, expanded) {
      const curr = this.tableTreeRefreshTool[tree.guid];
      curr.expandCount++;
      curr.prevStatus = expanded;
      this.refreshChildrenList(tree.guid);
    },
    refreshChildrenList(parentGuid) {
      const curr = this.tableTreeRefreshTool[parentGuid];
      if (curr && curr.prevStatus) {
        this.requestApi(
          "biz.customer.store.shelf.list",
          Object.assign({}, this.defaultParams, {
            parentGuid: parentGuid,
          })
        )
          .then((resp) => {
            return resp.data.list || [];
          })
          .catch((err) => {
            return [];
          })
          .then((resp) => {
            this.$set(
              this.$refs.table.store.states.lazyTreeNodeMap,
              parentGuid,
              resp.map((item) => {
                return Object.assign(
                  {
                    hasChildren: item.childrenCount > 0,
                  },
                  item
                );
              })
            );
          });
      }
    },
    refreshList() {
      if (this.storeGuid) {
        this.errorMsg = null;
        this.loading = true;
        return this.requestApi("biz.customer.store.shelf.list", this.defaultParams)
          .then((resp) => {
            this.loading = false;
            this.pageData = (resp.data.list || []).map((item) => {
              return Object.assign({ hasChildren: item.childrenCount > 0 }, item);
            });
          })
          .catch((err) => {
            this.loading = false;
            this.errorMsg =
              (err && (err.msg || err.message)) || "连接服务器失败，请检查网络";
          });
      } else {
        this.errorMsg = null;
        this.loading = false;
        this.pageData = null;
      }
    },
    refreshByRow(parentGuid) {
      this.refreshTool();
      this.refreshChildrenList(parentGuid);
      this.refreshList();
    },
    refreshTool() {
      (this.pageData || []).forEach((item) => {
        if (!item.hasChildren) {
          this.tableTreeRefreshTool[item.guid] = undefined;
          delete this.tableTreeRefreshTool[item.guid];
        }
      });
    },
  },
  mounted() {
    this.storeGuid = this.readState("curStoreGuid", "");
    this.refreshList();
  },
};
</script>
